import script from "./BooIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./BooIndex.vue?vue&type=script&setup=true&lang=js"

import "./BooIndex.vue?vue&type=style&index=0&id=ddef772c&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ddef772c"]])

export default __exports__